<template>
  <v-icon style="margin: 0px;" large :color="color">{{value}}</v-icon>
</template>

<style scoped>

</style>

<script>
  import IconCell from "./iconCell.ts";
  export default IconCell;
</script>